import {Component, OnInit, Input} from '@angular/core';
import {Device} from '../../../../../../models/device';
import {BagElement} from '../../../../../../models/bagElement';
import {DataStorageService} from '../../../../../data-storage.service';
import {ApiBagService} from '../../../../../apiServices/bag/api-bag.service';

@Component({
  selector: 'app-my-device-for-sale',
  templateUrl: './my-device-for-sale.component.html',
  styleUrls: ['./my-device-for-sale.component.scss']
})
export class MyDeviceForSaleComponent implements OnInit {

  @Input() device: Device;
  value: number;

  constructor(private dataStorageService: DataStorageService,
              private bagApi: ApiBagService) {
    this.value = 1;
  }

  ngOnInit() {
  }

  addToBag(dev: Device) {
    if (this.value !== 0 && this.dataStorageService.currentState.status === 'OPEN') {
      const device = new BagElement(dev, this.value);
      this.dataStorageService.currentState.deviceBag.push(device);
      this.dataStorageService.currentState.mergeBagElements();
      const updated = this.dataStorageService.currentState.deviceBag.filter( element => element.device.id === dev.id);
      this.dataStorageService.success = !this.dataStorageService.success;
      this.bagApi.putBagDevice(dev.id, updated[0].quantity);
      setTimeout(() => this.dataStorageService.success = false, 1000);
    }
  }

  getProfitMargin(): number {
    return Math.round(((this.device.salePrice - this.device.purchasePrice) / this.device.salePrice) * 100);
  }

  decrease() {
    if (this.value > 0) {
      this.value--;
    }
  }

  increase() {
    this.value++;
  }


}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/my-devices-data-base/my-devices-catalogue/my-device-for-sale/my-device-for-sale.component.ts